var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpicWins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#145F7F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0006 29.9986C23.2849 29.9986 30.0006 23.2829 30.0006 14.9986C30.0006 12.4171 29.3485 9.98786 28.2 7.8667C25.5627 5.56208 22.1114 4.16577 18.334 4.16577C10.0497 4.16577 3.33398 10.8815 3.33398 19.1658C3.33398 21.7473 3.98613 24.1765 5.13466 26.2977C7.77188 28.6023 11.2232 29.9986 15.0006 29.9986Z",
    fill: "#147095"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_20760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8798 18.6148L18.7029 17.2792L20.1883 16.7726L20.3529 15.2124L21.4704 14.1122L20.9391 12.6355L21.4704 11.1587L20.3529 10.0584L20.1883 8.49834L18.7029 7.99174L17.8798 6.65605L16.3229 6.84403L15.0004 6L13.6778 6.8441L12.121 6.65612L11.2978 7.99178L9.81242 8.49838L9.64786 10.0585L8.53027 11.1587L9.06162 12.6355L8.53027 14.1123L9.64782 15.2125L9.81239 16.7726L11.2978 17.2792L12.1209 18.6149L13.6778 18.4269L15.0004 19.271L16.3229 18.4269L17.8798 18.6148ZM10.4501 12.6355C10.4501 10.1265 12.4914 8.08526 15.0004 8.08526C17.5094 8.08526 19.5506 10.1265 19.5506 12.6355C19.5506 15.1445 17.5094 17.1857 15.0004 17.1857C12.4914 17.1857 10.4501 15.1445 10.4501 12.6355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 9.14062C13.0737 9.14062 11.5059 10.7084 11.5059 12.6355C11.5059 14.5626 13.0737 16.1304 15.0007 16.1304C16.9278 16.1304 18.4956 14.5626 18.4956 12.6355C18.4956 10.7084 16.9278 9.14062 15.0007 9.14062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4291 19.5197L11.577 19.7433L10.5985 18.1554L10.2659 18.042L8.83105 22.5267L11.4142 22.3847L13.4351 23.9997L14.6244 20.2826L13.4291 19.5197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4028 18.1554L18.4243 19.7433L16.5723 19.5197L15.377 20.2826L16.5662 23.9997L18.5872 22.3847L21.1703 22.5267L19.7354 18.042L19.4028 18.1554Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_20760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicWins);
export default __webpack_public_path__ + "static/media/epic-wins.a0011a2d98e213c195adc32ae3674d21.svg";
export { ForwardRef as ReactComponent };